
// src/pages/Login.jsx
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import  BASE_URL from "../constante";
import { useAuth } from "../context/AuthContext";




const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);
  const { login } = useAuth();

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberMeEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  // Connexion classique (email/password)
 const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/api/auth/login`,
        { email, password },
        { withCredentials: true }
      );

      if (res.data.user) {
        login(res.data.user); // save user in context

        // ✅ Handle Remember Me
        if (rememberMe) {
          localStorage.setItem("rememberMeEmail", email); // remember only email
        } else {
          localStorage.removeItem("rememberMeEmail");
        }

        if (!res.data.user.isApproved) {
          navigate("/waiting-approval");
        } else {
          navigate("/");
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };


  // Connexion Google
  const loginWithGoogle = () => {
    if (window.innerWidth > 768) {
      toast.info("Redirection vers Google…");
    }
    window.location.href = `${BASE_URL}/api/auth/google`;
  };

  


  return (
    <div className="auth-page d-flex align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7">
            <div className="auth-card animate-scaleIn">
              <div className="card-header-redesign text-center">
                <h3 className="text-gradient mb-2">Se connecter</h3>
              </div>              
              <div className="card-body-redesign">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Adresse e-mail</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Entrez votre e-mail"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Entrez votre mot de passe"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
  {/* Remember Me */}
  <div className="form-check mb-0">
    <input
      type="checkbox"
      className="form-check-input"
      id="rememberMe"
      checked={rememberMe}
      onChange={(e) => setRememberMe(e.target.checked)}
    />
    <label className="form-check-label" htmlFor="rememberMe">
      Se souvenir de moi
    </label>
  </div>

  {/* Forgot Password */}
  <Link to="/forgot-password" className="forgot-password-link">
    Mot de passe oublié ?
  </Link>
</div>


                  <button className="btn btn-primary w-100 mb-3"
                   type="submit"
                   disabled={loading} >
                   {loading && (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    )}
                    {loading ? "Connexion…" : "Se connecter"}
                  </button>
                </form>

                <div className="text-center mb-2 text-muted">OU</div>

                {/* Google */}
                <button
                  className="btn btn-google w-100 mb-2 social-btn gap-2"
                  onClick={loginWithGoogle}
                >
                  {/* SVG Google */}
                  <svg width="18" height="18" viewBox="0 0 48 48">
                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.7 1.22 9.2 3.6l6.9-6.9C35.9 2.3 30.4 0 24 0 14.6 0 6.5 5.4 2.6 13.3l8.5 6.6C13.1 13.2 18.1 9.5 24 9.5z"/>
                    <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-2.8-.4-4.1H24v7.8h12.8c-.5 3-2.1 5.6-4.6 7.3l7.1 5.5c4.2-3.9 6.8-9.6 6.8-16.5z"/>
                    <path fill="#FBBC05" d="M11.1 28.1c-.6-1.7-.9-3.5-.9-5.6s.3-3.9.9-5.6L2.6 13.3C.9 16.6 0 20.2 0 24s.9 7.4 2.6 10.7l8.5-6.6z"/>
                    <path fill="#34A853" d="M24 48c6.4 0 11.8-2.1 15.7-5.8l-7.1-5.5c-2 1.3-4.6 2.1-8.6 2.1-5.9 0-10.9-3.7-12.9-9l-8.5 6.6C6.5 42.6 14.6 48 24 48z"/>
                  </svg> 
                  Continuer avec Google
                </button>

   


                <div className="text-center mb-3">
                  <p className="text-muted auth-text">
                    Pas encore de compte ? <Link to="/register" className="text-decoration-none fw-semibold">Créer un compte</Link>
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
